import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'captalize'
})
export class CaptalizePipe implements PipeTransform {

  transform(value: unknown): string {
    if (value === null || value === undefined) return '';

    const text = String(value).toLocaleLowerCase();
    if (!text.length) return '';

    return text
      .split(' - ')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' - ');
  }
}